import React from "react";
import ReactDOM from "react-dom";
import { save } from "utils/proxy";
import { spUrl } from "utils";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "globals/css/variables/index.css";
import "globals/css/index.global.css";

import "./polifyll";

window.onerror = function (message, source, lineno, colno, error) {
	const loggingUrl = spUrl("/api/developers/log?level=ERROR");
	const payload = {
		message,
		source,
		lineno: lineno.toString(),
		colno: colno.toString(),
		error: JSON.stringify(error)
	};

	save(loggingUrl, payload);

	return false;
};

ReactDOM.render(<App/>, document.getElementById("root"));

serviceWorker.unregister();
